import * as yup from "yup";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Grid } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import TextInput from "../../../../components/hookForms/textField";
import messages from "../../../../utils/messages";
import serviceFaturaInstalacao from "../../../../services/serviceFaturaInstalacao";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { Loader, Dashed } from "./styles";
import DialogConfirm from "../../../../components/confirmationDialog";
export interface IDialogProps {
    open: boolean;
    onClose?: any;
    onCancel?: any;
    idProp?: any;
}

const schema = yup.object().shape({
    motivo: yup.string().required(messages.requiredField),
});

export default function DialogReopen({ open, onClose, onCancel, idProp }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);
    const [openModalFaturaPaga, setOpenModalFaturaPaga] = useState(false);
    const [prosseguirPendenciaSankhya, setProsseguirPendenciaSankhya] = useState(false);
    const [msgRetornoPendenciaSankhya, setMsgRetornoPendenciaSankhya] = useState("");
   
    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        resolver: yupResolver(schema),
    });

    const onSubmit = async (values: any) => {        
        setDisable(true);

        const reopenValues = {
            ...values,
            id: idProp.id,
            prosseguirPendenciaSankhya: prosseguirPendenciaSankhya
        };

        serviceFaturaInstalacao
            .reopen(reopenValues)
            .then((result) => {
                if (result && result.status === 200) {
                    if (result && result.data?.mensagemRetornoSankhya && result.data?.mensagemRetornoSankhya !== "") {
                        setMsgRetornoPendenciaSankhya(result.data?.mensagemRetornoSankhya);
                        setOpenModalFaturaPaga(true);                       
                    }
                    else{
                        toast.success("Fatura reaberta com sucesso!");
                        reset();
                        onClose(true);
                    }
                }
            })
            .finally(() => {
                setDisable(false);
            });
    };

    const onCancelReopen = () => {
        reset();
        onCancel(true);
    };

    return (
        <>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onCancel();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    Reabrir Fatura                  
                    <IconButton
                        aria-label="close"
                        onClick={onCancel}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Grid item xs={12}>
                            {isDisable && (
                                <Loader>
                                    <img alt="Loading" src="/Loading.gif" width="40px" height="40px" />
                                </Loader>
                            )}
                        </Grid>

                        <Typography variant="h5">Atenção:</Typography>
                        <Typography variant="body2">
                            * AO REABRIR UMA FATURA, VOCÊ TAMBÉM ESTARÁ CANCELANDO A FATURA DE CLIENTE!
                        </Typography>
                        <Dashed />
                        <Box>
                            <Box>
                                <Grid>
                                    <Typography variant="subtitle2">Fatura Instalação ID: {idProp?.id}</Typography>
                                    <Typography variant="subtitle2">Num. Instalação: {idProp?.numeroInstalacao}</Typography>
                                    <Typography variant="subtitle2">Ciclo: {idProp?.cicloFaturamento}</Typography>
                                </Grid>
 
                                <Grid container spacing={1}>
                                    <TextInput
                                        name="motivo"
                                        label="Descreva o Motivo"
                                        control={control}
                                        error={errors}
                                        multiline
                                        maxLength={150}
                                    />
                                </Grid>
                            </Box>
                            <Box></Box>
                        </Box>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button 
                            onClick={() => onCancelReopen()} 
                            color="warning" 
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Cancelar
                        </Button>

                        <Button
                            type="submit"
                            color="primary"
                            variant="contained"
                            disabled={isDisable}
                            style={{ width: "159px", height: "44px" }}
                            id="btnConfirmar"
                        >
                            Confirmar
                        </Button>

                        <DialogConfirm
                            open={openModalFaturaPaga}
                            title={"Reabrir Fatura: Retorno Sankhya"}
                            message={
                                "O Sankhya retornou a seguinte mensagem: '" + (msgRetornoPendenciaSankhya ? 
                                msgRetornoPendenciaSankhya : "") + "'. Deseja continuar com a Reabertura mesmo assim?"
                            }
                            cancelButtonText={"Cancelar"}
                            confirmButtonText={"Confirmar"}
                            onClose={() => setOpenModalFaturaPaga(false)}
                            onCancel={() => {
                                setProsseguirPendenciaSankhya(false);
                                setOpenModalFaturaPaga(false);
                                setMsgRetornoPendenciaSankhya("");
                                onClose(true);
                            }}
                            onConfirm={() => {
                                setProsseguirPendenciaSankhya(true);
                                setOpenModalFaturaPaga(false);
                                setMsgRetornoPendenciaSankhya("");

                                setTimeout(() => {
                                    const el =  document.getElementById("btnConfirmar") as HTMLElement;

                                    if (el) {
                                        el.click();
                                    }
                                }, 500);
                            }}
                        />
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}
